import { Resource } from "./resource";
import { ResourceItem } from "./resources/ResourceItem";
import qs from "qs";

export interface CsvActions {
  fetchCsvList(params?: any): Promise<any>;
}

export function createCsvResource(actionUrl: string): Resource<CsvActions> {
  return (client) => ({
    async fetchCsvList(params?: any) {
      const resp = await client.get(actionUrl, {
        params: {
          ...params,
          format: "csv",
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "comma" });
        },
      });
      return resp.data;
    },
  });
}
